<ng-container *transloco="let t; prefix: 'payment.wizard.stepFour'">
    <!-- Header -->
    <div class="flex flex-col w-full gap-2 items-center justify-center">
        <h2 class="rfs:text-[40px] text-center font-semibold text-black">
            {{t('header')}}
        </h2>
        <p class="rfs:text-xl text-center font-light text-tone-09">
            {{t('infoText')}}
        </p>
    </div>
    <!-- END OF Header -->

</ng-container>